import styled, { css } from 'styled-components';
import { spaces } from '@99designs/ui/settings';

interface IconWrapperProps {
    size: string;
}
export const IconWrapper = styled.span<IconWrapperProps>(({ size }) => {
    return css`
        display: inline-block;
        height: ${size};
        width: ${size};
        line-height: 1;
        margin-left: ${spaces.inlineIcon}px;
    `;
});
